import AuthService from "./AuthService";

export default AuthService;
